/** @format */

import React, { useEffect, useState, useCallback } from "react";
import { KeywordSearch } from "mydnv/components/keyword-search";
import { PaginationControl } from "mydnv/components/pagination";
import { useMyDNVContext } from "mydnv/context/mydnv-context";
import * as followService from "mydnv/services/follow-service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ConfirmOperationModal } from "mydnv/layout/full-width-myDNV/confirm-operation-modal";
import { NavLink } from "react-router-dom";
import { Config } from "config";
import dayjs from "dayjs";

export const FollowingsPanel = ({ followingsPerPage = 25 }) => {
    const [followings, setFollowings] = useState([]);
    const [searchFilterText, setSearchFilterText] = useState("");
    const [filterableFollowings, setFilterableFollowings] = useState([]);
    const [paginationDisplayableFollowings, setPaginationDisplayableFollowings] = useState([]);
    const [optionsToggledFollowing, setOptionsToggledFollowing] = useState(null);
    const [modalToggleState, setModalToggleState] = useState(false);
    const [followingToDelete, setFollowingToDelete] = useState(null);

    let {
            instance,
            account,
        } = useMyDNVContext();
        // const { error, webpage, model } = useSimpliCity();
        // const { title, description } = model || {};
    
        const loginRequest = Config.MyDNV.loginRequest;

    const runApiCall = useCallback(
            (callback, ...args) => {
                const request = {
                    ...loginRequest,
                    account: account,
                };
    
                instance
                    .acquireTokenSilent(request)
                    .then((response) => {
                        if (args.length > 0) {
                            callback(response.accessToken, ...args);
                        } else {
                            callback(response.accessToken);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            },
            [account, instance, loginRequest],
        );

    const fetchFollowings = async (accessToken) => {
            let response = await followService.getFollowings(accessToken);
            setFollowings(response.data);
        };

    const postFollowingDeletion = async (token, webpage) => await followService.postUnfollow({ token, webpage });
    const handleFollowingDelete = (following) => {
        let followingIndex = followings.findIndex((followingEntry) => followingEntry.guid === following.guid);
        let followingToRemove = followings[followingIndex];
        let newFollowingsList = [
            ...followings.slice(0, followingIndex),
            ...followings.slice(followingIndex + 1, followings.length),
        ];

        runApiCall(postFollowingDeletion, followingToRemove);
        setFollowings(newFollowingsList);
    };

    // const handleSignIn = useCallback(() => {
    //         instance.loginRedirect(loginRequest).catch((e) => {
    //             console.error(e);
    //         });
    //     }, [instance, loginRequest]);

    const updatePaginationDetails = useCallback(
        (newStartingPosition, filteredFollowings = filterableFollowings) => {
            let paginationPositionLimit =
                newStartingPosition + followingsPerPage;

            // need to add the +1 to the index since the pagination position values are [1...] rather than the index variable which is [0...]
            setPaginationDisplayableFollowings(
                filteredFollowings.filter(
                    (_, index) =>
                        index + 1 >= newStartingPosition &&
                        index + 1 < paginationPositionLimit
                )
            );
        },
        [filterableFollowings, followingsPerPage]
    );

    const updateFollowingsContent = useCallback((filteredFollowings = followings) => {
        setFilterableFollowings(filteredFollowings);
        updatePaginationDetails(1, filteredFollowings);
    }, [followings, updatePaginationDetails]);

    // useEffect(() => {
    //         if (isAuthenticated && inProgress === InteractionStatusNone) {
    //             runApiCall(fetchFollowings);
    //         } else {
    //             if (inProgress === InteractionStatusNone) {
    //                 handleSignIn();
    //             }
    //         }
    //     }, [fetchFollowings, handleSignIn, inProgress, isAuthenticated, InteractionStatusNone, runApiCall]);

    useEffect(() => {
        runApiCall(fetchFollowings);
    }, []);

    useEffect(() => {
        updateFollowingsContent();
        window.addEventListener("click", handleButtonClickListener);
        return () =>
            window.removeEventListener("click", handleButtonClickListener);

        // eslint-disable-next-line
    }, [followings]);


    const handleButtonClickListener = (event) => {
        let openOptionsMenuElement = Array.from(
            document.getElementsByClassName("followingOptions show")
        );
        let optionsButtonElement = Array.from(
            document.getElementsByClassName("openFollowingOptionsPanel")
        );

        if (
            optionsButtonElement.length > 0 &&
            !optionsButtonElement.some((element) =>
                element.contains(event.target)
            ) &&
            openOptionsMenuElement.length > 0 &&
            !openOptionsMenuElement[0].contains(event.target)
        ) {
            setOptionsToggledFollowing(null);
        }
    };

    const clearSearchFilter = () => {
        setSearchFilterText("");
        updateFollowingsContent();
    };

    const handleResetFilterListOnEmptySearch = (searchString) => {
        if (searchString.length === 0) {
            updateFollowingsContent();
        }
    };

    const handleFilterFollowings = (searchString) => {
        let filteredFollowings = followings.filter((following) =>
            following.title
                .toLowerCase()
                .includes(searchString.toLowerCase())
        );
        updateFollowingsContent(filteredFollowings);
    };

    // eslint-disable-next-line no-unused-vars
    const getFilteredDate = (dateEntry) => {
        let date = new Date(dateEntry);
        return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(
            -2
        )}-${("0" + date.getDate()).slice(-2)}`;
    };

    const openFollowingOptionsPanel = (following) => {
        if (optionsToggledFollowing === null) {
            setOptionsToggledFollowing(following);
        } else {
            setOptionsToggledFollowing(null);
        }
    };

    const isToggledFollowing = (following) => {
        return (
            optionsToggledFollowing !== null &&
            optionsToggledFollowing.guid === following.guid
        );
    };

    const handleModal = (isDeleteRequested) => {
        if (isDeleteRequested) {
            handleFollowingDelete(followingToDelete);
        }
        closeModal();
    };

    const openModal = (following) => {
        setModalToggleState(true);
        setFollowingToDelete(following);
    };

    const closeModal = () => {
        setModalToggleState(false);
        setFollowingToDelete(null);
    };

    // const convertUTCDateToLocalDate = (date) => {
    //     var newDate = new Date(
    //         date.getTime() - date.getTimezoneOffset() * 60 * 1000
    //     );
    //     var offset = date.getTimezoneOffset() / 60;
    //     var hours = date.getHours();
    //     newDate.setHours(hours - offset);
    //     return newDate;
    // };

    const formatDateForDisplay = (dateStr) => {
        let date = new Date(dateStr);
        let localConvertedDate = dayjs(date).utc(true).local().format("YYYY-MM-DD");
        // let displayDate = getFilteredDate(localConvertedDate);
        return localConvertedDate;
    };

    return (
        <>
            <div className='followingsPanelCard'>
                <div className='cardRow'>

                        {followings.length === 0 && (
                            <div className='noContentSaved'>
                                <span>
                                    Pages you are watching will appear here.
                                </span>
                            </div>
                        )}
                        {followings.length > 0 && (
                            <>
                                <KeywordSearch
                                    inputValue={searchFilterText}
                                    onInputChange={(e) => {
                                        setSearchFilterText(e.target.value);
                                        handleResetFilterListOnEmptySearch(e.target.value);
                                    }}
                                    onClearSearchFilter={clearSearchFilter}
                                    onFilterContent={handleFilterFollowings}
                                    displayableItemsLength={
                                        paginationDisplayableFollowings.length
                                    }
                                    totalItemsLength={filterableFollowings.length}
                                />

                                {paginationDisplayableFollowings.length ===
                                    0 && (
                                    <div className='nopages'>
                                        Pages you watch will appear here.
                                    </div>
                                )}

                                {paginationDisplayableFollowings.length > 0 && (
                                    <>
                                        <div className='followingsTableMobile'>
                                            {paginationDisplayableFollowings.map(
                                                (following) => (
                                                    <div
                                                        className='followingsTableDataRow'
                                                        key={following.guid}
                                                    >
                                                        <div className='cardLeftContent'>
                                                            <div className='PageCol'>
                                                                <NavLink to={following.path}>
                                                                    {following.title}
                                                                </NavLink>
                                                            </div>
                                                            <div className='DateUpdatedCol'>
                                                                Updated:{" "}
                                                                {formatDateForDisplay(
                                                                    following.updated_Date
                                                                )}
                                                            </div>
                                                            <div className='DateAddedCol'>
                                                                Date added:{" "}
                                                                {formatDateForDisplay(
                                                                    following.created_Date
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className='cardRightContent'>
                                                            <div className='followingRemoveBtn'>
                                                                <button
                                                                    onClick={() =>
                                                                        openModal(
                                                                            following
                                                                        )
                                                                    }
                                                                >
                                                                    <span>
                                                                        <FontAwesomeIcon icon='fas fa-trash-alt' />
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>

                                        <div className='followingsTable'>
                                            <div className='followingsTableHeader'>
                                                <div className='PageCol'>
                                                    Page
                                                </div>
                                                <div className='DateUpdatedCol'>
                                                    Last updated
                                                </div>
                                                <div className='DateAddedCol'>
                                                    Date added
                                                </div>
                                                <div className='extraActionsCol'></div>
                                            </div>

                                            {paginationDisplayableFollowings.map(
                                                (following) => (
                                                    <div
                                                        className='followingsTableDataRow'
                                                        key={following.guid}
                                                    >
                                                        <div className='PageCol'>
                                                            <NavLink to={following.path}>
                                                                {following.title}
                                                            </NavLink>
                                                        </div>
                                                        <div className='DateUpdatedCol'>
                                                            {formatDateForDisplay(
                                                                following.updated_Date
                                                            )}
                                                        </div>
                                                        <div className='DateAddedCol'>
                                                            {formatDateForDisplay(
                                                                following.created_Date
                                                            )}
                                                        </div>
                                                        <div className='extraActionsCol'>
                                                            <button
                                                                className='openFollowingOptionsPanel'
                                                                onClick={() =>
                                                                    openFollowingOptionsPanel(
                                                                        following
                                                                    )
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon='fas fa-ellipsis-v' />
                                                            </button>

                                                            <div
                                                                className={`followingOptions ${
                                                                    isToggledFollowing(
                                                                        following
                                                                    )
                                                                        ? "show"
                                                                        : ""
                                                                }`}
                                                            >
                                                                <button
                                                                    onClick={() =>
                                                                        openModal(
                                                                            following
                                                                        )
                                                                    }
                                                                >
                                                                    Stop
                                                                    watching
                                                                    <span>
                                                                        <FontAwesomeIcon icon='fas fa-trash-alt' />
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>

                                        <PaginationControl
                                            contentPerPage={followingsPerPage}
                                            totalContentLength={
                                                followings.length
                                            }
                                            onPaginationUpdate={
                                                updatePaginationDetails
                                            }
                                        />
                                    </>
                                )}
                            </>
                        )}
                </div>
            </div>

            <ConfirmOperationModal
                isOpen={modalToggleState}
                setModalOpen={handleModal}
                headerText='Stop watching this page?'
                paragraphText="You'll no longer receive notifications about future updates."
                okButtonText='Yes, stop watching'
            />
        </>
    );
};
